import React from "react";
import PropTypes from "prop-types";
import { Button, Checkbox } from "day8-ui";
import { MdOutlineHouseboat } from "@react-icons/all-files/md/MdOutlineHouseboat";
import { getSelectedFilters, onFilterSelect, setDefaultCabinsCrewFilter } from "../../../../helpers/filter";
import { FILTERS } from "../../../../constants";
import { useDispatch } from "react-redux";

const BookingTypeFilter = props => {
  const dispatch = useDispatch();
  const { cabinBookingType } = getSelectedFilters(props.location);
  const selectedFilterText = cabinBookingType ? "Cabins" : "Yachts";
  const handleSelection = (filterType, isSelectedCabinBookingType) => {
    onFilterSelect(props.location, dispatch, props.filterAction, filterType, isSelectedCabinBookingType);
    setDefaultCabinsCrewFilter();
  };
  const options = [
    {
      label: 'Yachts',
      value: 'Yachts',
      checked: !cabinBookingType
    },
    {
      label: 'Cabins',
      value: 'Cabins',
      checked: !!cabinBookingType
    }
  ];
  return props.mobile ? (
    <div className={props.className}>
      <div>
        <Checkbox
          label="Booking Type"
          onClick={e => handleSelection(FILTERS.CABIN_BOOKING_TYPE, e.target.value === "Yachts" ? null : true)}
          options={options}
        />
      </div>
    </div>
  ) : <Button buttonType="LINK" onClick={props.filterModalToggle} leftIcon={<MdOutlineHouseboat />}>{selectedFilterText || 'Booking Type'}</Button>;
};
BookingTypeFilter.propTypes = {
  weeks: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
  setPage: PropTypes.func,
  mobile: PropTypes.bool,
  renderFilterMenuButton: PropTypes.bool,
  filterModalToggle: PropTypes.bool,
  className: PropTypes.string,
  filterAction: PropTypes.func.isRequired
};
export default BookingTypeFilter;
